import BulkActionsConfirmActionStep from "components/BulkActions/ConfirmActionStep";
import { BulkActionsVariant } from "components/BulkActions/types";

import {
  IdpGroupRolesBulkActionsAnalyticsPayload,
  IdpGroupRolesBulkActionsSelectedAction,
} from "../types";
import UserRolesBulkActionsConfirmActionStepDefault from "./Default";
import { IdpGroupRolesBulkActionsConfirmActionStepProps } from "./types";
import { IdpGroupRolesMutationVariables } from "../useIdpGroupRolesBulkActions/types";

type IdpGroupRolesBulkActionsConfirmActionFormProps = {
  action: IdpGroupRolesBulkActionsSelectedAction;
  variant: BulkActionsVariant;
  onConfirm: (
    mutationVariables: IdpGroupRolesMutationVariables,
    analyticsPayload: IdpGroupRolesBulkActionsAnalyticsPayload
  ) => void;
  onCancel: () => void;
};

const UserRolesBulkActionsConfirmActionForm = ({
  action,
  variant,
  onConfirm,
  onCancel,
}: IdpGroupRolesBulkActionsConfirmActionFormProps) => {
  const props: IdpGroupRolesBulkActionsConfirmActionStepProps = {
    bulkActionsVariant: variant,
    onConfirm,
    onCancel,
    action,
  };

  const actionComponent = <UserRolesBulkActionsConfirmActionStepDefault {...props} />;

  return <BulkActionsConfirmActionStep>{actionComponent}</BulkActionsConfirmActionStep>;
};

export default UserRolesBulkActionsConfirmActionForm;
